import { useDeepMemo } from '@global/hooks/useDeepMemo'
import { createContext, Dispatch, ReactElement, useReducer } from 'react'
import { initialState as defaultInitialState, reducer } from './reducer'
import { Action, State } from './types'

interface ContextValue {
  state: State
  dispatch: Dispatch<Action>
}

export const SelectiveDatasetContext = createContext<ContextValue>({
  state: defaultInitialState,
  dispatch: () => {
    // do nothing
  },
})

interface Props {
  children: ReactElement | ReactElement[]
  initialState?: State
}

export const SelectiveDatasetProvider = ({
  children,
  initialState = defaultInitialState,
}: Props) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const value = useDeepMemo(() => ({ state, dispatch }), [state, dispatch])

  return (
    <SelectiveDatasetContext.Provider value={value}>{children}</SelectiveDatasetContext.Provider>
  )
}
